import { render } from "./ListNotIntegrated.vue?vue&type=template&id=54f6cdc1&scoped=true"
import script from "./ListNotIntegrated.vue?vue&type=script&lang=js"
export * from "./ListNotIntegrated.vue?vue&type=script&lang=js"

import "./ListNotIntegrated.vue?vue&type=style&index=0&id=54f6cdc1&scoped=true&lang=css"

import exportComponent from "/var/www/bauminas/prod/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54f6cdc1"]])

export default __exports__